import debounce from '../helpers/debounce';
import syncXScroll from '../helpers/syncXScroll';
/**
 * Position: fix of element relativ to Container
 */
export default class PositionStickyVertical {
  /**
   * constructor
   * @param {object} [options]
   */
  constructor(options = {}) {
    this.config = {
      selector: {
        container: '[data-pos-sticky-container]',
        element: '[data-pos-sticky-y-element]',
      },
      modifier: 'position-sticky-vertical',
      buffer: 15,
      ...options,
    };
    this.containerList = document.querySelectorAll(this.config.selector.container);
    if (!this.containerList.length) {
      return;
    }
    this.handleFixPositionRange();
    this.bindEvents();
  }

  /**
   * Bind window scroll event
   */
  bindEvents() {
    window.addEventListener('scroll', debounce(() => {
      this.handleFixPositionRange();
    }, 10));
  }

  /**
   * activate sticky header when table header is out of viewport
   * deactivate when container is out of viewport
   * sync x-scroll position
   */
  handleFixPositionRange() {
    this.containerList.forEach((container) => {
      const fixedElemList = container.querySelectorAll(this.config.selector.element);
      const modifiedElements = container.querySelectorAll(`.${this.config.modifier}`);
      const startPosition = container.offsetTop - this.config.buffer;
      // eslint-disable-next-line max-len
      const endPosition = container.offsetTop + container.offsetHeight - fixedElemList[0].offsetHeight;
      const enterContainer = window.pageYOffset > startPosition;
      const leaveContainer = window.pageYOffset > endPosition;
      if (enterContainer && !leaveContainer) {
        this.handleFixPositionElement(fixedElemList, true);
      } else {
        this.handleFixPositionElement(modifiedElements, false);
      }
      syncXScroll(container, fixedElemList);
      container.addEventListener('scroll', debounce(() => {
        syncXScroll(container, fixedElemList);
      }, 10));
    });
  }

  /**
   * set css class for fixed positioning
   * @param {HTMLAllCollection} elements - all elements to set fixed
   * @param {boolean} setFix
   */
  handleFixPositionElement(elements, setFix) {
    elements.forEach((element) => {
      if (setFix) {
        element.classList.add(this.config.modifier);
      } else {
        element.classList.remove(this.config.modifier);
      }
    });
  }
}
